import React from "react";
import "./BillingOverview.css";

const BillingOverview = () => {
  const cardsData = [
    {
      title: "Total sales (period)",
      value: "₹83.7L",
      subtitle: "84.6% clinic · 15.4% pet shop",
    },
    {
      title: "Total outstanding",
      value: "₹60.5L",
      subtitle: "avg DSO 25.2 days (month)",
    },
    {
      title: "Collection rate (week)",
      value: "98.8%",
      subtitle: "vs 2.8% last week — see note",
    },
    {
      title: "Returns (period)",
      value: "7",
      subtitle: "sales returns on record",
    },
  ];

  return (
    <div className="billing-overview-container">
      <h2 className="billing-overview-title">Billing overview</h2>
      <div className="billing-overview-cards-grid">
        {cardsData.map((card, index) => (
          <div className="billing-overview-card" key={index}>
            <h4 className="billing-overview-card-title">{card.title}</h4>
            <div className="billing-overview-card-value-container">
              <h2 className="billing-overview-card-value">{card.value}</h2>
            </div>
            <div className="billing-overview-card-subtitle">
              {card.subtitle}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BillingOverview;
